import { memo } from 'react';
import { UseControllerProps, useController, UseFormSetValue } from 'react-hook-form';
import { Select } from 'src/components/common';
import { CustomSelectProps } from 'src/components/common/Select';

const FormSelect = ({ control, setValue, ...props }: Props) => {
  const { field, fieldState } = useController({ name: props.name, control: control });

  return (
    <Select
      label={props.label}
      {...props}
      {...field}
      onChange={setValue}
      errorMessage={fieldState.error?.message}
    />
  );
};

type Props<T = any> = UseControllerProps<T> &
  CustomSelectProps & {
    setValue: UseFormSetValue<T>;
  };

export default memo(FormSelect);
